import { render, staticRenderFns } from "./MainFaqs.vue?vue&type=template&id=4ff6db2e&scoped=true&"
import script from "./MainFaqs.vue?vue&type=script&lang=js&"
export * from "./MainFaqs.vue?vue&type=script&lang=js&"
import style0 from "./MainFaqs.vue?vue&type=style&index=0&id=4ff6db2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff6db2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
